export default {
  stage: '阶段',
  child: "子项"
};
